import { render, staticRenderFns } from "./email.vue?vue&type=template&id=33d06612&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d06612')) {
      api.createRecord('33d06612', component.options)
    } else {
      api.reload('33d06612', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=33d06612&", function () {
      api.rerender('33d06612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/email/email.vue"
export default component.exports